import Store from 'store/store';
import { addClass, removeClass, accessNested } from 'utils/utils';
import { getMainPage } from 'utils/bolt';

const navigationHistory = [];
Store.on('LANDING', ({ page }) => {
	navigationHistory.push(page);
});

Store.on('SET_ACTIVE_PAGE', page => {
	if (navigationHistory[navigationHistory.length - 1] !== page) {
		navigationHistory.push(page);
	}
});

let videosShowing = false;
let returnFocusTo;
Store.on('OPEN_VIDEO_OVERLAY', (overlayId, queryString) => {
	if (videosShowing) {
		return;
	}
	returnFocusTo = document.activeElement;
	Store.emit('CLOSE_ALL_OVERLAYS');
	videosShowing = true;
	Store.emit('SET_ACTIVE_PAGE', overlayId || 'boltVideos', queryString);

	const isRootPath = accessNested(Store.get(), `appData.pages.${overlayId}.path`, '') === '/';

	if (!isRootPath) {
		// Don't show the option to close overlay if the site only has a videos page or videos & showtimes
		Store.emit('SET_HEADER_ACTION', {
			icon: 'close',
			action: () => Store.emit('CLOSE_VIDEO_OVERLAY'),
			tag: 'closeVideoOverlay'
		});
	}
	Store.get().videos.set({ overlayOpen: overlayId || 'boltVideos' });
	Store.get().header.set({ videoOverlayOpen: true });
	addClass(document.body, 'locked');
});

Store.on('CLOSE_VIDEO_OVERLAY', (updateActivePage = true) => {
	if (!videosShowing) {
		return;
	}

	videosShowing = false;
	let store = Store.get();
	store.videos.set({ overlayOpen: false });
	store.header.set({ videoOverlayOpen: false });
	Store.emit('REMOVE_HEADER_ACTIONS', 'closeVideoOverlay');

	const pages = Object.values(accessNested(store, 'appData.pages', {}));

	if (updateActivePage) {
		const rootPageExclusions = ['error-404', 'browser-not-supported', 'bolt-toolkit'];
		let rootPage = pages.find(page => page.path === '/' && !rootPageExclusions.includes(page.id));
		rootPage = rootPage.id ? rootPage.id : getMainPage();
		const navigateTo = navigationHistory[navigationHistory.length - 2] || rootPage;
		Store.emit('CLOSE_AND_NAVIGATE', navigateTo);
	}
	removeClass(document.body, 'locked');

	if (returnFocusTo) {
		try {
			// Wait for the next render
			setTimeout(() => returnFocusTo.focus());
		} catch {}
	}
});

Store.on('CHANGE_ACTIVE_VIDEO', (video) => {
	// if (window.location.hash) {
	// 	window.history.replaceState({}, document.title, '.');
	// }
	Store.get().videos.set({ activeVideo: video });
});

Store.on('CLOSE_ALL_OVERLAYS', () => {
	Store.emit('CLOSE_VIDEO_OVERLAY', false);
});
